import { useEffect, useState } from "react";
import { AutocompleteInput } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomFilterSelect from "./CustomFilterSelect";

const FilterVendors = (props: any) => {
  const [vendorList, setVendorList] = useState([]);
  useEffect(() => {
    const fetchVendorList = async () => {
      const reqUrl = "vendors/shortList";
      await sendRequest(reqUrl, {
        id: 1,
        data: {
          status: 1, //only active products
        },
      }).then((response) => {
        if (response) {
          setVendorList(response);
        }
      });
    };
    fetchVendorList();
  }, []);

  const vendorData = [
    { id: "", name: "Please select" },
    ...vendorList.map((vendor: any) => {
      return { id: vendor.sName, name: vendor.sName };
    }),
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      label="Referral Source"
      source="vendor_name"
      choices={vendorData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterVendors;
